import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/apiClient";
import { PageHeader } from "@/components/dashboard/primitives";
import { Button } from "@/components/ui/button";
import EventForm, { emptyEvent } from "@/components/dashboard/EventForm";

export default function EventNew() {
  const navigate = useNavigate();
  const [form, setForm] = useState(emptyEvent);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/events", form);
      toast.success("Event created");
      navigate(`/events/${data.id}`);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="p-5 sm:p-8 max-w-2xl">
      <Link to="/events" className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground mb-4">
        <ArrowLeft className="h-4 w-4" /> Back to events
      </Link>
      <PageHeader title="Create an event" subtitle="Set up your event. You can add sessions next." />
      <form onSubmit={submit} className="rounded-xl border border-border bg-card p-6" data-testid="event-new-form">
        <EventForm form={form} setForm={setForm} />
        <div className="flex gap-3 pt-6 mt-6 border-t border-border">
          <Button type="submit" disabled={loading} className="rounded-md bg-accent text-accent-foreground hover:opacity-90 transition-opacity" data-testid="event-create-submit">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Create event"}
          </Button>
          <Button type="button" variant="outline" className="rounded-md" onClick={() => navigate("/events")}>Cancel</Button>
        </div>
      </form>
    </div>
  );
}
